var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { "hide-footer": "", title: "Dateieigenschaften ändern" },
      on: {
        hide: function ($event) {
          return _vm.reset()
        },
      },
      model: {
        value: _vm.isModalOpen,
        callback: function ($$v) {
          _vm.isModalOpen = $$v
        },
        expression: "isModalOpen",
      },
    },
    [
      _c(
        "div",
        { staticClass: "record-files-edit-modal" },
        [
          _c(
            "csp-desktop-info-card",
            {
              attrs: {
                cols: 12,
                "form-context": _vm.currentFormContext,
                icon: "inticon-users",
                title: "Dateieigenschaften",
              },
              on: { "cancel-form": _vm.reset, save: _vm.saveFileEditFormData },
            },
            [
              _c("csp-desktop-info-card-element", {
                attrs: {
                  "form-context": _vm.currentFormContext,
                  label: "Neuer Dateiname",
                  property: "fileName",
                  required: true,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                attrs: {
                  "form-context": _vm.currentFormContext,
                  label: "Zuordnung",
                  "options-loader": _vm.loadFileCategoryGroupOptions,
                  property: "fileCategoryGroup",
                  required: true,
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                attrs: {
                  "auto-select-single-option": true,
                  dependencies: ["fileCategoryGroup"],
                  "form-context": _vm.currentFormContext,
                  label: "Kategorie",
                  "options-loader": _vm.loadFileCategoryOptions,
                  property: "fileCategory",
                  required: true,
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }